export default __webpack_public_path__ + "static/media/controls_mouse_2.a140acfb.svg";